import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReservationController } from '../reservation.controller';
import { Action, NavigationDataKey, NavigationType } from '@shared-libs/enums';
import { PrintingProvider } from '@internal-providers/printing.provider';
import { PrintingService } from '@shared-services/print.service';
import { CancelReservationComponent } from '@internal-components/event-components/cancel-reservation-component/cancel-reservation.component';
import { IQuestionCategory } from '@internal-models/question-category.model';
import { QuestionCategoryComponent } from '@internal-components/administration-components/question-category-components/question-category-component/question-category.component';

@Component({
	selector: 'reservation-desktop-component',
	templateUrl: 'reservation.desktop.component.html',
	styleUrls: ['./reservation.desktop.component.scss'],
})
export class ReservationDesktopComponent implements OnInit, OnDestroy {
	constructor(
		public readonly controller: ReservationController,
		private readonly printingProvider: PrintingProvider,
		private readonly printingService: PrintingService
	) {}

	public async ngOnInit(): Promise<void> {
		this.controller.onInit();
	}
	public ngOnDestroy(): void {
		this.controller.onDestroy();
	}

	public async print(): Promise<void> {
		const html =
			this.controller.event.attendanceType === this.controller.EventAttendanceType.Lessons
				? await this.printingProvider.getHTMLConfirmationForLessonReservation(this.controller.reservation.id)
				: await this.printingProvider.getHTMLConfirmationForReservation(this.controller.reservation.id);
		await this.printingService.print(html);
	}

	public async deleteReservation(): Promise<void> {
		const reservationId = this.controller.reservationForm.value.id;
		const communication = this.controller.reservationForm.value.Communication;
		this.controller.navigationService
			.navigateTo<{
				action: Action;
				cancellation: { CancellationReasonId: string; cancellationInfo: string };
			}>(NavigationType.modal, CancelReservationComponent, {
				reservation: this.controller.reservation,
				calendarEvent: this.controller.calendarEvent,
				event: this.controller.event,
				eventAttendanceType: this.controller.type,
			})
			.then(async (result) => {
				if (result?.action === Action.DELETE) {
					const reservation = await this.controller.reservationProvider.delete(
						reservationId,
						result.cancellation,
						communication
					);
					this.controller.navigationService.navigateBack({ action: Action.UPDATE, reservation });
				}
			});
	}

	public async createQuestionCategory(): Promise<void> {
		void this.controller.navigationService
			.navigateTo<{ questionCategory: IQuestionCategory }>(NavigationType.modal, QuestionCategoryComponent, {
				action: Action.CREATE,
			})
			.then((result) => {
				if (result?.questionCategory) {
					this.controller.questionCategories.push(result.questionCategory);
					this.addQuestionCategoryToForm(result.questionCategory.id);
				}
				this.controller.navigationDataManager.addData(
					NavigationDataKey.reservationForm,
					this.controller.reservationForm
				);
			})
			.catch();
	}

	private addQuestionCategoryToForm(questionCategoryId: string): void {
		const currentCategories = this.controller.reservationForm.get('Attendance.QuestionCategories').value;
		this.controller.reservationForm
			.get('Attendance.QuestionCategories')
			.setValue([...currentCategories, questionCategoryId]);
	}
}
